const AppConfig = {
    api: {
        url: 'http://localhost:3008/'
    },
    auth: {
        isLoggedIn: 'loggedInLaosAsean2023',
        accessToken: 'accessTokenLaosAsean2023',
        userRole: 'userRole',
    }
}

export default AppConfig;
